<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" [routerLink]="['/firmware-update-group']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "FIRMWARE_UPDATE" | translate }}
      </h2>
    </div>
  </div>

  <form [formGroup]="firmwareUpdateForm">
    <div class="form-item pt-4">
      <label class="form-label" for="region">{{ "DEVICESETUP_REGION" | translate }}</label>
      <div class="form-input">
        <select id="region" (change)="onRegionChange($event)" [value]="''" [disabled]="availableRegions.length === 0">
          <option value=""></option>
          <option *ngFor="let region of availableRegions" [value]="region.value">
            {{ region.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 d-flex align-items-center">
            <div class="validation-error" *ngIf="submitted && selectedRegions.length === 0">
              {{ "DEVICESETUP_REGION" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-center justify-content-end clear" *ngIf="selectedRegions.length > 0"
            (click)="clearSelectedRegions()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          *ngIf="selectedRegions.length > 0">
          <div *ngFor="let region of selectedRegions"
            class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ region.name }}</span>
            <img (click)="removeRegion(region)" alt="Remove Region" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="area">{{ "DEVICESETUP_AREA" | translate }}</label>
      <div class="form-input">
        <select id="area" (change)="onAreaChange($event)" [value]="''" [disabled]="areas.length === 0">
          <option value=""></option>
          <option *ngFor="let area of availableAreas" [value]="area.value" [disabled]="isSelectedArea(area)">
            {{ area.name }}
          </option>
        </select>
        <div class="row m-0">
          <div class="col-md-6 d-flex align-items-center justify-content-end clear" *ngIf="selectedAreas.length > 0"
            (click)="clearSelectedAreas()">
            <span>{{ "CLEAR" | translate }}</span>
          </div>
        </div>
        <div class="row-md-12 selected-container custom-margins mt-3 d-flex flex-wrap gap-3"
          *ngIf="selectedAreas.length > 0">
          <div *ngFor="let area of selectedAreas" class="selected ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center">
            <span class="pe-2">{{ area.name }}</span>
            <img (click)="removeArea(area)" alt="Remove Area" src="assets/core/filter/filter-x.svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="meterMake">{{ "DEVICESETUP_METERMAKE" | translate }}</label>
      <div class="form-input">
        <select id="meterMake" formControlName="meterMakeId" (change)="onMeterMakeChange()">
          <option value=""></option>
          <option *ngFor="let meterMake of meterMakes" [value]="meterMake.value">
            {{ meterMake.name }}
          </option>
        </select>
        <div class="validation-error" *ngIf="submitted && meterMakeIdControl.invalid">
          {{ "DEVICESETUP_METERMAKE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="meterModel">{{ "DEVICESETUP_METERMODEL" | translate }}</label>
      <div class="form-input">
        <select id="meterModel" formControlName="meterModelId" (change)="onMeterModelChange()">
          <option value=""></option>
          <option *ngFor="let meterModel of meterModels" [value]="meterModel.id">
            {{ getMeterModelLabel(meterModel) }}
          </option>
        </select>
        <div class="validation-error" *ngIf="submitted && meterModelIdControl.invalid">
          {{ "DEVICESETUP_METERMODEL" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="firmwareVersion">{{ "FIRMWAREVERSION" | translate }}</label>
      <div class="form-input">
        <select id="firmwareVersion" formControlName="targetMeterModelId">
          <option value=""></option>
          <option *ngFor="let meterModel of filteredTargetMeterModels" [value]="meterModel.id">
            {{ meterModel.firmwareVersion }}
          </option>
        </select>
        <div class="validation-error" *ngIf="submitted && targetMeterModelIdControl.invalid">
          {{ "FIRMWAREVERSION" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
        </div>
      </div>
    </div>

    <div class="form-item">
      <label class="form-label" for="maximumAttempts">{{ "FIRMWARE_UPDATE_RETRY" | translate }}</label>
      <div class="form-input">
        <div class="attempts-row">
          <input id="maximumAttempts" type="number" min="1" max="10" step="1" formControlName="maxRetries" />
          <button type="button" class="attempt-btn" (click)="decrement()">-</button>
          <button type="button" class="attempt-btn" (click)="increment()">+</button>
          <button type="button" class="attempt-btn clear-btn" (click)="clearRetries()">
            {{ "CLEAR" | translate }}
          </button>
        </div>
        <div class="validation-error" *ngIf="submitted && maxRetriesControl.invalid">
          {{ "FIRMWARE_UPDATE_RETRYERROR" | translate }}
        </div>
      </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="schedule-panel" *ngIf="showSchedulePanel">
      <span class="schedule-panel-label">{{ "SCHEDULE_UPDATE_FOR_LATER" | translate }}</span>
      <div class="schedule-fields">
        <app-date-picker class="date-picker-wrap" [value]="scheduledDateControl.value"
          (valueChange)="setScheduledDate($event)" [placeholder]="'FIRMWARE_SCHEDULE_DATE' | translate"
          [disablePastDates]="true">
        </app-date-picker>
        <app-time-picker class="time-picker-wrap" [value]="scheduledTimeControl.value"
          (valueChange)="setScheduledTime($event)" [placeholder]="'FIRMWARE_SCHEDULE_TIME' | translate"
          [disablePastTimes]="true" [minDate]="scheduledDateControl.value">
        </app-time-picker>
      </div>
      <div class="validation-error"
        *ngIf="submitted && showSchedulePanel && (!scheduledDateControl.value || !scheduledTimeControl.value)">
        {{ "SCHEDULE_UPDATE_FOR_LATER" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
      </div>
    </div>

    <div class="actions">
      <div *ngIf="!showSchedulePanel; else backToUpdateActions" [routerLink]="['/firmware-update-group']">
        <button class="button-cancel" type="button">
          {{ "CANCEL" | translate }}
        </button>
      </div>
      <ng-template #backToUpdateActions>
        <button class="button-cancel" type="button" (click)="showSchedulePanel = false">
          {{ "FIRMWARE_CANCEL_SCHEDULE" | translate }}
        </button>
      </ng-template>
      <div class="btn-group-update" *ngIf="showSchedulePanel; else updateNowButtons">
        <div class="btn-update-now" [class.disabled]="!canSchedule"
          (click)="canSchedule ? scheduleUpdate() : submitted = true">
          <span>{{ "FIRMWARE_SCHEDULE" | translate }}</span>
        </div>
      </div>
      <ng-template #updateNowButtons>
        <div class="btn-group-update">
          <div class="btn-update-now" [class.disabled]="!canUpdate"
            (click)="canUpdate ? updateNow() : submitted = true">
            <span>{{ "FIRMWARE_START_NOW" | translate }}</span>
          </div>
          <div class="btn-clock" (click)="showSchedulePanel = true">
            <svg-icon src="assets/device/hour.svg"></svg-icon>
            <svg-icon src="assets/device/chevron-down.svg" class="btn-clock-chevron"></svg-icon>
          </div>
        </div>
      </ng-template>
    </div>
  </form>
</div>
